define('viewmodels/pages/cash/deposit/ChooseDepositValuableViewModel',[], function () {

    var ChooseDepositValuableViewModel = function(getField) {
        this.title = getField('choose_deposit_valuable_page_title');
    };

    return ChooseDepositValuableViewModel;
});

